import { InhouseTicketSystemType } from '@api';
import { TouringCardTable, TouringCardTableBody } from '@common';
import { VenueInhouseTicketSystemTableRow } from './components';
import { venueInhouseTicketSystemRows } from './data';

type VenueInhouseTicketSystemTablePropsType = {
  venueInhouseTicketSystem: InhouseTicketSystemType;
};

export const VenueInhouseTicketSystemTable: React.FC<VenueInhouseTicketSystemTablePropsType> = ({
  venueInhouseTicketSystem,
}) => {
  return (
    <TouringCardTable>
      <TouringCardTableBody>
        {venueInhouseTicketSystemRows.map((row) => (
          <VenueInhouseTicketSystemTableRow
            key={row.label}
            venueInhouseTicketSystem={venueInhouseTicketSystem}
            row={row}
          />
        ))}
      </TouringCardTableBody>
    </TouringCardTable>
  );
};

